import axios from 'axios';

const arrayAggregateReport = [
    '/aggregate/platform/kpi',
    '/aggregate/aps/subscriptions',
    '/aggregate/services/kpi',
    '/aggregate/system/properties',
    '/aggregate/ba/payment/plugins',
    '/aggregate/ba/domain/plugins',
    '/aggregate/ba/ssl/plugins',
    '/aggregate/ba/container/plugins',
    '/aggregate/ba/fraud/plugins',
    '/aggregate/slave/os',
    '/aggregate/mn/os',
    '/aggregate/pdl/packages',
    '/aggregate/connect/subscriptions',
    '/aggregate/aps/seats',
    '/aggregate/aps/o365seats'
];

export default class AggregatedService {

    public getAggregateReportByDate(key, date): Promise<any> {
        let requestUrl;
        if (date) {
            requestUrl = '/api' + arrayAggregateReport[key - 1] + '?date=' + date;
        } else {
            requestUrl = '/api' + arrayAggregateReport[key - 1];
        }
        return new Promise<any>((resolve, reject) => {

            axios.get(requestUrl)
                .then(function(res) {
                    resolve(res);
                }).catch(err => {
                reject(err);
            });
        });
    }

    public getAggregateReportFile(key, date) {
        let requestUrl;
        if (date) {
            requestUrl = '/api/download' + arrayAggregateReport[key - 1] + '?date=' + date;
        } else {
            requestUrl = '/api/download' + arrayAggregateReport[key - 1];
        }
        return new Promise<any>(resolve => {
            axios.get(requestUrl)
                .then(function(res) {
                    resolve(res);
                });
        });
    }

    public getAggregateReportByDateFile(type, date): Promise<any> {
        let requestUrl;
        if (date) {
            requestUrl = '/api/aggregate/type/date?type=' + type + '&date=' + date;
        } else {
            requestUrl = '/api/aggregate/type/date?type=' + type;
        }
        return new Promise<any>(resolve => {
            axios.get(requestUrl)
                .then(function(res) {
                    resolve(res);
                })
                .catch(function(res) {
                    resolve(res);
                });
        });
    }
}
